module.exports = __webpack_public_path__ + "media/images/shared/arrow-right-3fd3b3182383afa03221dd52c7abd5e2.svg";